import {IonAvatar, IonButton, IonButtons, IonChip, IonCard, IonCardContent, IonText, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonLabel, IonList, IonMenuButton, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRouterLink, IonRow, IonSegment, IonSegmentButton, IonSelect, IonSelectOption, IonTitle, IonToolbar, RefresherEventDetail, useIonModal, useIonRouter, IonItem, IonThumbnail} from '@ionic/react';
import {useStoreState} from 'pullstate';

import styles_Common from "./Common.module.scss";
import styles_8_1 from "./Pg_8_1.module.scss";
import styles_A_0 from './Pg_A_0.module.scss';
import {getPageData} from "../store/Selectors";
import React, {Fragment, useEffect, useRef, useState} from "react";
import {chevronDownCircleOutline, personCircle} from "ionicons/icons";
import {useAppUtil, useSideMenuOptions, useSideMenuUpdate} from "../components/sideMenu/SideMenuProvider";
import CustomPage from "./CustomPage";
import {useFormInput, validateForm} from "../_/useForms";
import indexBy from "underscore/modules/indexBy";
import {handleCommonFetchErrors, navToPg_1_25, navToPg_2_3, promptBrowserToLogin} from "./Utils";
import moment from "moment/moment";
import CustomField from "../components/CustomField";
import {AuthStore} from "../store/Common_Store";
import {fetch_Pg_7_1, Pg_7_1_Store} from "../store/Pg_7_Store";

import {ActionLink} from "../components/ActionLink";
import classNames from 'classnames';
import useForceRender from "../_/useForceRender";
import logo from "../srcicons/logo.svg";
import {push_pg_A_1__Logout} from "../store/Pg_A_Store";
import {fetch_Pg_8_1, Pg_8_1_Store} from "../store/Pg_8_Store";

const customSelectContainerOptions_您的寵物名字 = {
    header: '您的寵物名字',
    subHeader: '',
    message: '請選擇一項',
    translucent: false,
};


const customSelectContainerOptions_選取風格 = {
    header: '選取風格',
    subHeader: '',
    message: '請選擇一項',
    translucent: false,
};

const useMyFields = () => {
    return [
        {
            id: "p1",
            label: "您的寵物名子",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "您的寵物名子",

                },
                state: useFormInput("")
            }
        },
        {
            id: "p2",
            label: "選取風格",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "選取風格",

                },
                state: useFormInput("")
            }
        },
        {
            id: "p3",
            label: "做甚麼?",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "做甚麼?",

                },
                state: useFormInput("")
            }
        },
        {
            id: "p4",
            label: "在哪裡?",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "在哪裡?",

                },
                state: useFormInput("")
            }
        },
    ];
}


const Pg_8_1 = (props) => {
    const pageRef = useRef();
    const pageName = "Pg_8_1";
    const pageId = "Pg_8_1";
    const {sideMenuOptions} = props;
    const setSideMenu: any = useSideMenuUpdate();
    const sideMenu: any = useSideMenuOptions();

    const forceRender = useForceRender();

    const router = useIonRouter();

    const appUtil = useAppUtil();

    ///#region 會員
    const authStore = useStoreState(AuthStore, getPageData);
    const hasAuthed = authStore?.signBy ?? false;
    //const Item_會員 = hasAuthed ? authStore?.AuthData : undefined;
    ///#endregion

    useEffect(() => {
        setSideMenu({options: sideMenuOptions, side: "start", pageName: pageId});
    }, []);

    //#region Data Loading
    useEffect(() => {
        (async () => {
            let errorObj = await fetch_Pg_8_1();
            handleCommonFetchErrors(router, errorObj);
        })();
    }, []);

    let reload = async (event: CustomEvent<RefresherEventDetail>) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        let errorObj = await fetch_Pg_8_1();
        handleCommonFetchErrors(router, errorObj);
        event?.detail?.complete();
    }

    const pgData = useStoreState(Pg_8_1_Store, getPageData);

    const hasLoaded = pgData?.Root ?? false;

    const Item_Root = hasLoaded ? pgData.Root : undefined;
    const Item_會員 = hasLoaded ? pgData.Box_Header.Item_會員 : undefined;

    if (hasLoaded) {
        //debugger;
    }

    //#endregion

    const navToPg_3_1 = () => {
        router.push("/tabs/3_1", "forward", "push");
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }

    //#region push logout
    const push_logout = async () => {
        await appUtil.toast.present('登出中...', 10000)
        if (await push_pg_A_1__Logout({})) {
            await appUtil.toast.dismiss();
            await appUtil.toast.present('登出成功', 1000)

            promptBrowserToLogin();
        }
    }
    //#endregion

    return (
        <IonPage id={pageId}>
            <CustomPage name={pageId} sideMenu={false} sideMenuPosition="start" backButton={false}>
                {/*<IonRefresher slot="fixed" onIonRefresh={reload}>*/}
                {/*    <IonRefresherContent*/}
                {/*        pullingIcon={chevronDownCircleOutline}*/}
                {/*        pullingText="Pull to refresh"*/}
                {/*        refreshingSpinner="circles"*/}
                {/*        refreshingText="Refreshing...">*/}
                {/*    </IonRefresherContent>*/}
                {/*</IonRefresher>*/}

                {!hasLoaded && <Fragment>
                    <>
                        {/*<IonGrid className="ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom">*/}
                        {/*    <div>*/}
                        {/*        讀取中，讀取可能牽涉到AI計算，請稍後*/}
                        {/*    </div>*/}
                        {/*</IonGrid>*/}
                    </>
                </Fragment>}

                {hasLoaded && <Fragment>
                    {/*<BannerTopSwipe/>*/}
                    <>
                        {!Item_會員 &&
                            <IonGrid>
                                <IonRow>
                                    <IonCol className="ion-justify-content-center ion-text-center w100 ion-padding">
                                        未登錄無法使用，請刷新頁面登入
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        }

                        <IonGrid className="ion-padding">
                            <IonRow>
                                <IonCol size="12" className={styles_8_1.headingText}>
                                    <IonCardTitle color="primary">Welcome</IonCardTitle>
                                    <h4>{Item_會員.暱稱} ！ <ActionLink link={`/`} onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();

                                        appUtil.menu.elementRef.current.close()
                                        push_logout();

                                        return false;
                                    }}>登出</ActionLink></h4>
                                </IonCol>
                            </IonRow>
                        </IonGrid>

                        <ActionLink link={`/tabs/8_5`} noLink={false}>
                            <IonCard className={classNames(styles_A_0.cardbg, styles_8_1.cardContainer)}>
                                <IonCardHeader>
                                    <IonCardTitle>建立會員紀錄</IonCardTitle>
                                    {/*<IonCardSubtitle>Card Subtitle</IonCardSubtitle>*/}
                                </IonCardHeader>
                                <IonCardContent>
                                    <div className={classNames("fl", styles_Common.footerText)}>
                                        <div>紀錄查詢</div>
                                        {/*<div>匯出Excel檔</div>*/}
                                        <div>直接建立帳號</div>
                                        <div>透過訪客填表建立帳號</div>
                                    </div>
                                </IonCardContent>
                            </IonCard>
                        </ActionLink>
                    </>
                </Fragment>
                }



                {/*<IonGrid className={classNames("ion-padding", styles_Common.footer)}>*/}
                {/*    <div className={styles_Common.footerInnerContainer}>*/}
                {/*        <IonRow>*/}
                {/*            <IonCol size="12">*/}
                {/*                <IonIcon className={classNames(styles_Common.footerIcon, "fl")} src={logo}></IonIcon>*/}
                {/*                <IonIcon className={classNames(styles_Common.footerIcon, "fr")} src="/assets/icon/logo-youtube.svg"></IonIcon>*/}
                {/*            </IonCol>*/}
                {/*        </IonRow>*/}

                {/*        <IonRow>*/}
                {/*            <IonCol size="12" className={styles_Common.footerTextContainer}>*/}
                {/*                <div className={classNames("fl", styles_Common.footerText)}>*/}
                {/*                    <div>EMJ</div>*/}
                {/*                    <div>PetJourney.ai</div>*/}
                {/*                    <div>SDGs Passport</div>*/}
                {/*                    <div>xxxxxxxxx</div>*/}
                {/*                </div>*/}
                {/*            </IonCol>*/}
                {/*        </IonRow>*/}
                {/*    </div>*/}
                {/*</IonGrid>*/}

            </CustomPage>

        </IonPage>
    );
};

export default Pg_8_1;
